<template>
  <v-dialog v-model="visible" scrollable :overlay="false" :max-width="maxWidth" transition="dialog-transition">
    <v-card width="1800px">
      <v-toolbar color="blue white--text darken-3" flat>
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-0">
        <template v-if="previsualizacion">
          <v-img v-if="esImagen" class="estilo-imagen" :src="previsualizacion" width="100%"></v-img>

          <iframe v-else class="estilo-pdf" :src="previsualizacion" width="100%" height="100%"></iframe>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-btn color="blue darken-1" v-if="esImagen" text @click.prevent="descargar">
          <v-icon>mdi-download</v-icon>

          Descargar
        </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalVerPdf',
  data() {
    return {
      visible: false,
      previsualizacion: null,
    };
  },
  computed: {
    esImagen() {
      return this?.previsualizacion?.includes('image');
    },
    extension() {
      return this.previsualizacion ? this.previsualizacion.split(';')[0].split('/')[1] : null;
    },
    titulo() {
      return this.esImagen ? 'Ver Imagen' : 'Ver PDF';
    },
    maxWidth() {
      return this.esImagen ? '800px' : '1800px';
    },
  },
  methods: {
    abrir(previsualizacion) {
      if (previsualizacion.includes('image')) {
        this.previsualizacion = previsualizacion;
      } else if (previsualizacion.includes('pdf')) {
        const base64 = previsualizacion.split(',')[1];
        const blob = new Blob([Buffer.from(base64, 'base64')], {
          type: previsualizacion.split(';')[0].split(':')[1],
        });
        const url = URL.createObjectURL(blob);

        this.previsualizacion = url;
      } else {
        this.previsualizacion = previsualizacion;
      }

      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    descargar() {
      const link = document.createElement('a');

      link.href = this.previsualizacion;
      link.download = `${new Date().getTime()}.${this.extension}`;
      link.click();
    },
  },
};
</script>

<style>
.estilo-pdf {
  height: calc(var(--vh, 1vh) * 100 - 15rem);
}

.estilo-imagen {
  max-height: calc(var(--vh, 1vh) * 100 - 15rem);
  background: #dfdfdf;
}

.estilo-imagen .v-image__image {
  background-size: contain;
}
</style>